import { render } from "./TelaSucesso.vue?vue&type=template&id=6e7651bf&scoped=true"
import script from "./TelaSucesso.vue?vue&type=script&lang=js"
export * from "./TelaSucesso.vue?vue&type=script&lang=js"

import "./TelaSucesso.vue?vue&type=style&index=0&id=6e7651bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7651bf"]])

export default __exports__